
import RoutePlanning from './planning-container';

export default RoutePlanning;